<template>
  <img
    :class="{ loading: !loaded }"
    :src="src"
    :alt="alt"
    @load="loaded = true"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue';

defineProps<{
  src: string;
  alt?: string;
}>();

const loaded = ref(false);
</script>
